import { NgModule } from '@angular/core';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { MutualModule } from '@shared/mutual/mutual.module';
import { CtaSectionBlockComponent, SectionFormBlockLayoutComponent, SectionOutlineBlockComponent } from './components';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';

@NgModule({
  imports: [MutualModule, PipesSharedModule, NzToolTipModule],
  exports: [SectionFormBlockLayoutComponent, SectionOutlineBlockComponent, CtaSectionBlockComponent],
  declarations: [SectionFormBlockLayoutComponent, SectionOutlineBlockComponent, CtaSectionBlockComponent],
  providers: [],
})
export class LayoutsModule {}
